<script setup lang="ts">
import { computed, ref } from 'vue';
import { loadResources } from '/@stores/resources';
import { Resource } from '/@types/resources';
import Icons from '/@utilities/icons';

const props = defineProps<{
  initialGuid: string;
}>();

const model = defineModel<Set<string>>({ default: () => new Set() });

if (props.initialGuid) model.value = new Set([props.initialGuid]);

const equipmentSearchModel = ref('');

const allEquipments = ref<Resource[]>([]);

loadResources({ type: 'equipment' }).then((res) => {
  allEquipments.value = res ?? [];
});

const equipmentMap = computed(() => new Map(allEquipments.value.map((e) => [e.guid, e])));

const filteredEquipments = computed(() =>
  allEquipments.value.filter((e) =>
    e.name.toLowerCase().includes(equipmentSearchModel.value.toLowerCase()),
  ),
);

function toggleEquipment(guid: string) {
  const next = new Set(model.value);
  next.has(guid) ? next.delete(guid) : next.add(guid);
  model.value = next;
}
</script>

<template>
  <df-select
    class="dl__group dl__group--large"
    label="Utstyr"
    v-on:open="equipmentSearchModel = ''"
  >
    <template v-slot:text>
      {{
        [...model].map((guid) => equipmentMap.get(guid)?.name ?? 'ukjent utstyr').join(', ')
      }}
    </template>
    <div>
      <df-input-search v-model="equipmentSearchModel" class="user-menu_input" />
      <df-dropdown2-item
        v-for="eq in filteredEquipments"
        :key="eq.guid"
        v-on:click="toggleEquipment(eq.guid)"
        no-close
      >
        <div class="listitem">
          <df-icon :code="model.has(eq.guid) ? Icons.SquareCheck : Icons.Square" />
          <div>{{ eq.name }}</div>
        </div>
      </df-dropdown2-item>
    </div>
  </df-select>
</template>

<style scoped>
.listitem {
  display: grid;
  gap: var(--gap-md);
  grid-template-columns: max-content 1fr;
  align-items: center;
}

.user-menu_input {
  padding: var(--gap-md);
}
</style>
